import type { LoginMutationVariables, ResetPasswordMutationVariables, VerifyCustomerAccountMutationVariables } from '#graphql-operations'
import { login, logout, resetPassword } from '~/services/auth'

export const useAuth = () => useNuxtApp().$auth

export async function authLogin(body: LoginMutationVariables) {
  const localePath = useLocalePath()

  await login(body)

  const { redirectTo } = useRoute().query as { redirectTo?: string }
  await useAuth().refreshActiveCustomer()
  await navigateTo(redirectTo || localePath('/'))
}

export async function verifyCustomerAccount(body: VerifyCustomerAccountMutationVariables) {
  const localePath = useLocalePath()
  // NOTE: This acts as authRegister, because email verification is required
  await useGraphqlMutation('verifyCustomerAccount', body)
  await useAuth().refreshActiveCustomer()
  const { redirectTo } = useRoute().query as { redirectTo?: string }
  await navigateTo(redirectTo || localePath('/'))
}

export async function authLogout() {
  const store = useStore()
  const activeOrderStore = useActiveOrderStore()
  await logout()
  store.value.activeCustomer = store.value.activeOrder = null
  await useAuth().refreshActiveCustomer()
  await activeOrderStore.refetchActiveOrder()
}

export async function authResetPassword(body: ResetPasswordMutationVariables) {
  const localePath = useLocalePath()
  await resetPassword(body)
  const { redirectTo } = useRoute().query as { redirectTo?: string }
  await useAuth().refreshActiveCustomer()
  await navigateTo(redirectTo || localePath('/'))
}
